import React from 'react';
import { Button, Grid, MenuItem, TextField } from '@mui/material';
import { PlanningCycleFilters as FilterModel } from './planningCycle.models';

type Option = { rid?: number; id?: number; shc?: string; code?: string; nam?: string; name?: string };

type Props = {
  value: FilterModel;
  budgetPeriods: Option[];
  states: Option[];
  phases: Option[];
  loading?: boolean;
  onChange: (value: FilterModel) => void;
  onApply: () => void;
  onClear: () => void;
};

class PlanningCycleFilters extends React.PureComponent<Props> {
  idOf = (x: Option) => Number(x.rid ?? x.id ?? 0);
  nameOf = (x: Option) => x.nam ?? x.name ?? x.shc ?? x.code ?? '';

  renderSelect(label: string, value: any, options: Option[], onChange: (v: any) => void) {
    return (
      <TextField select size="small" label={label} value={value ?? ''} onChange={(e) => onChange(e.target.value)} fullWidth>
        <MenuItem value="">All</MenuItem>
        {options.map((x) => (
          <MenuItem key={this.idOf(x)} value={this.idOf(x)}>{this.nameOf(x)}</MenuItem>
        ))}
      </TextField>
    );
  }

  render() {
    const { value } = this.props;
    return (
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 3 }}>
          {this.renderSelect('Budget Period', value.budgetperiodid, this.props.budgetPeriods, (v) =>
            this.props.onChange({ ...value, budgetperiodid: v ? Number(v) : null }))}
        </Grid>

        <Grid size={{ xs: 12, md: 2 }}>
          {this.renderSelect('State', value.stateid, this.props.states, (v) =>
            this.props.onChange({ ...value, stateid: v ? Number(v) : null }))}
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          {this.renderSelect('Current Phase', value.phaseid, this.props.phases, (v) =>
            this.props.onChange({ ...value, phaseid: v ? Number(v) : null }))}
        </Grid>

        <Grid size={{ xs: 12, md: 2 }}>
          <TextField
            select
            size="small"
            label="Status"
            value={value.status ?? 1}
            onChange={(e) => this.props.onChange({ ...value, status: Number(e.target.value) })}
            fullWidth
          >
            <MenuItem value={1}>Active Records</MenuItem>
            <MenuItem value={0}>Inactive Records</MenuItem>
          </TextField>
        </Grid>

        <Grid size={{ xs: 12, md: 2 }}>
          <Grid container spacing={1}>
            <Grid size={{ xs: 6 }}>
              <Button variant="contained" onClick={this.props.onApply} disabled={this.props.loading} fullWidth>
                Apply
              </Button>
            </Grid>
            <Grid size={{ xs: 6 }}>
              <Button variant="outlined" onClick={this.props.onClear} disabled={this.props.loading} fullWidth>
                Clear
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default PlanningCycleFilters;
